export const articleData = [
  {
    id: 1,
    slug: 'actor-midnight-date',
    title: '知名演员张某某深夜密会神秘女子，独家照片曝光',
    subtitle: '据知情人士透露，该演员已婚多年，此次深夜密会引发婚变猜测',
    category: '明星黑料',
    date: '2026-07-05',
    author: '51爆料编辑部',
    heat: '128.5万',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20dark%20city%20street%20at%20night%20with%20dramatic%20lighting%2C%20mysterious%20silhouettes%20near%20an%20apartment%20building%2C%20warm%20street%20lamp%20glow%2C%20film%20grain%20texture%2C%20editorial%20photography%20style%2C%20moody%20noir%20atmosphere&width=1600&height=700&seq=article-hero-01&orientation=landscape',
    contentSections: [
      {
        type: 'paragraph',
        text: '近日，有网友向51黑料吃瓜网独家爆料称，知名演员张某某于7月4日深夜被拍到与一名神秘女子共同返回位于北京朝阳区的某高档公寓。据目击者描述，两人举止亲密，在公寓楼下停留约15分钟后一同进入电梯。',
      },
      {
        type: 'paragraph',
        text: '张某某现年42岁，已婚并育有一子。其妻子为圈外人，两人于2015年低调结婚，婚后张某某一直以"好丈夫"形象示人。此次深夜密会事件曝光后，迅速在社交媒体上引发热议。',
      },
      {
        type: 'heading',
        text: '独家照片细节分析',
      },
      {
        type: 'paragraph',
        text: '51黑料吃瓜网获取的独家照片显示，当晚约23:40，张某某驾驶一辆黑色商务车抵达该公寓地下车库。一名身穿白色连衣裙的长发女子从副驾驶下车，两人一前一后进入电梯间。照片虽为远距离拍摄，但经过专业影像分析，可以确认男性当事人确为演员张某某。',
      },
      {
        type: 'paragraph',
        text: '值得注意的是，张某某当天白天还在横店拍摄新剧，晚间即驱车近两小时赶回北京，这一反常举动更加引发外界猜测。',
      },
      {
        type: 'heading',
        text: '圈内人士爆料',
      },
      {
        type: 'paragraph',
        text: '一位不愿透露姓名的圈内人士告诉51爆料网："他们俩的事情其实在圈内不算秘密了，只是没想到会被拍到。女方是某影视公司的高管，两人因合作项目认识，已经交往了大概半年左右。"',
      },
      {
        type: 'paragraph',
        text: '该人士还透露，张某某与妻子的关系近年来确实出现裂痕，双方已就离婚事宜进行过多轮私下协商，但目前因财产分割和孩子抚养权问题尚未达成一致。',
      },
      {
        type: 'heading',
        text: '当事人及团队暂未回应',
      },
      {
        type: 'paragraph',
        text: '截至发稿前，张某某及其工作室均未对此事做出公开回应。记者多次致电其经纪人，电话均处于无人接听状态。其妻子方面同样保持沉默。',
      },
      {
        type: 'paragraph',
        text: '51黑料吃瓜网将持续关注此事进展，为大家带来第一手报道。各位吃瓜群众，你们觉得这次事件会如何发展？欢迎在评论区留言讨论！',
      },
    ],
  },
  {
    id: 2,
    slug: 'influencer-tax-evasion',
    title: '知名网红李某某涉嫌偷税漏税超千万，税务部门已正式立案',
    subtitle: '该网红名下多家公司存在异常资金流动，补缴税款及罚款或达数千万',
    category: '网红大瓜',
    date: '2026-07-04',
    author: '51爆料编辑部',
    heat: '256.3万',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20luxurious%20modern%20office%20interior%20with%20dramatic%20lighting%2C%20documents%20scattered%20on%20a%20desk%2C%20moody%20atmosphere%20with%20warm%20golden%20accents%2C%20film%20grain%20texture%2C%20editorial%20photography%20style%2C%20investigative%20journalism%20vibe&width=1600&height=700&seq=article-hero-02&orientation=landscape',
    contentSections: [
      {
        type: 'paragraph',
        text: '51黑料吃瓜网从权威渠道获悉，知名网红李某某因涉嫌偷逃税款，已被税务部门正式立案调查。据初步核算，其偷逃税款金额可能超过千万元人民币，加上滞纳金和罚款，最终需要补缴的金额或将达到数千万元。',
      },
      {
        type: 'heading',
        text: '涉案金额惊人',
      },
      {
        type: 'paragraph',
        text: '据了解，李某某在全网拥有超过3000万粉丝，年收入保守估计超过8000万元。其主要收入来源包括直播带货佣金、品牌代言费以及自创品牌的销售收入。然而，税务机关在例行检查中发现，其名下多家关联公司存在收入申报异常、成本虚列等问题。',
      },
      {
        type: 'paragraph',
        text: '一位税务专业人士向51爆料网透露："从目前掌握的情况来看，这并非简单的申报疏忽，而是有组织、有预谋的逃税行为。通过设立空壳公司、签订虚假合同等方式转移收入，手段相当隐蔽。"',
      },
      {
        type: 'heading',
        text: '直播带货行业震动',
      },
      {
        type: 'paragraph',
        text: '此消息一出，整个直播带货行业为之震动。多位头部主播紧急调整了税务筹划方案，部分主播甚至暂停了直播活动。业内分析认为，这可能是继薇娅事件后，税务部门对直播行业的又一次集中整治行动。',
      },
      {
        type: 'paragraph',
        text: '李某某的直播间目前已处于停播状态，其抖音和小红书账号的最新内容停留在7月2日。品牌合作方也在紧急评估影响，部分品牌已暂停与李某某的代言合约。',
      },
      {
        type: 'heading',
        text: '粉丝反应两极分化',
      },
      {
        type: 'paragraph',
        text: '事件发酵后，李某某的粉丝群体出现了明显的分裂。一部分忠实粉丝认为"谁还没犯过错"，呼吁给李某某一次改过自新的机会；另一部分粉丝则表示"太失望了"，认为偷税行为伤害了公众的信任。',
      },
      {
        type: 'paragraph',
        text: '51黑料吃瓜网将密切关注案件进展，第一时间为吃瓜群众带来最新消息。对于网红逃税问题，你怎么看？欢迎在评论区留言！',
      },
    ],
  },
  {
    id: 3,
    slug: 'top-star-diva-behavior',
    title: '顶流艺人赵某某片场耍大牌，多名工作人员匿名爆料',
    subtitle: '迟到早退、随意改剧本、辱骂工作人员，知情人士揭露片场真实情况',
    category: '明星黑料',
    date: '2026-07-06',
    author: '51爆料编辑部',
    heat: '312.1万',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20movie%20set%20with%20dramatic%20lighting%20equipment%2C%20empty%20directors%20chair%2C%20moody%20atmosphere%2C%20film%20grain%20texture%2C%20editorial%20photography%20style%2C%20dark%20and%20mysterious%20vibe%20with%20warm%20spotlights&width=1600&height=700&seq=article-hero-03&orientation=landscape',
    contentSections: [
      {
        type: 'paragraph',
        text: '近日，51黑料吃瓜网收到多位自称在赵某某新剧剧组工作的人员匿名爆料，揭露了这位顶流艺人在片场的种种不当行为。这些爆料涉及迟到早退、随意修改剧本、对工作人员态度恶劣等多方面问题，引发广泛关注。',
      },
      {
        type: 'heading',
        text: '迟到成为常态',
      },
      {
        type: 'paragraph',
        text: '据一位剧组工作人员透露："赵某某几乎每天都迟到，原定早上8点开工，他经常拖到10点甚至11点才出现。全组几百号人就等着他一个人，白白浪费大量时间和经费。有一次因为他的迟到，一整天的拍摄计划全部被打乱，导致剧组多花了近百万的额外支出。"',
      },
      {
        type: 'paragraph',
        text: '另一位匿名爆料人补充道："导演对他也很无奈，毕竟是投资方指定的人选。有几次导演委婉提醒，赵某某当场就翻脸了，场面非常尴尬。"',
      },
      {
        type: 'heading',
        text: '随意修改剧本引发矛盾',
      },
      {
        type: 'paragraph',
        text: '爆料人还称，赵某某经常在拍摄现场临时要求修改剧本。"他觉得自己的台词不够出彩，就要求编剧当场重写。有几次编剧加班到凌晨写的剧本，第二天被他一句话就否了。编剧组的同事都快被他逼疯了。"',
      },
      {
        type: 'heading',
        text: '对工作人员态度恶劣',
      },
      {
        type: 'paragraph',
        text: '最令人气愤的是，多位爆料人都提到赵某某对普通工作人员的态度极其恶劣。"有一次化妆师不小心碰到了他的头发，他当场就破口大骂，把人家小姑娘都骂哭了。还有一次场务递水慢了几秒钟，他就把水杯摔在地上。"',
      },
      {
        type: 'paragraph',
        text: '51黑料吃瓜网尝试联系赵某某的工作室求证，但截至发稿前未获回应。该剧制片方则表示"不便对演员的个人行为做出评论"。各位吃瓜群众，对于顶流艺人的"大牌行为"，你们怎么看？',
      },
    ],
  },
  {
    id: 4,
    slug: 'livestreamer-fake-goods',
    title: '知名带货主播陈某某涉嫌售假被立案，涉案金额数千万',
    subtitle: '消费者投诉直播间购买的名牌包鉴定为假货，监管部门突击检查仓库',
    category: '网红大瓜',
    date: '2026-07-03',
    author: '51爆料编辑部',
    heat: '445.6万',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20warehouse%20filled%20with%20luxury%20shopping%20bags%20and%20boxes%2C%20dramatic%20investigative%20lighting%2C%20moody%20atmosphere%2C%20film%20grain%20texture%2C%20editorial%20photography%20style%2C%20dark%20shadows%20with%20warm%20amber%20accents&width=1600&height=700&seq=article-hero-04&orientation=landscape',
    contentSections: [
      {
        type: 'paragraph',
        text: '51黑料吃瓜网独家获悉，知名带货主播陈某某因涉嫌销售假冒奢侈品，已被市场监管部门立案调查。据悉，涉案金额高达数千万元，这是近年来直播带货领域最大的一起售假案件之一。',
      },
      {
        type: 'heading',
        text: '消费者投诉牵出惊天大案',
      },
      {
        type: 'paragraph',
        text: '事件的导火索来自一名消费者在社交平台上的维权帖。该消费者称在陈某某直播间购买了一款"正品保证"的名牌手袋，收到货后发现做工粗糙，经专业机构鉴定确认为假货。该帖迅速获得大量转发，随后更多消费者站出来反映类似遭遇。',
      },
      {
        type: 'paragraph',
        text: '据不完全统计，已有超过200名消费者向监管部门投诉，涉及金额从几千元到数十万元不等。有消费者甚至一次性购买了价值30余万元的"名牌腕表"，鉴定结果同样为假货。',
      },
      {
        type: 'heading',
        text: '仓库突击检查发现大量假货',
      },
      {
        type: 'paragraph',
        text: '7月2日，市场监管部门联合公安对陈某某位于义乌的仓库进行了突击检查。据知情人士透露，现场查获了大量假冒国际知名品牌的箱包、腕表、服饰等商品，初步估值超过2000万元。技术人员还在现场查获了用于伪造防伪标识的专用设备。',
      },
      {
        type: 'heading',
        text: '直播行业信任危机',
      },
      {
        type: 'paragraph',
        text: '陈某某售假事件对整个直播带货行业造成了巨大冲击。多位行业分析师认为，如果不能建立有效的质量监管机制，直播带货行业将面临严重的信任危机。',
      },
      {
        type: 'paragraph',
        text: '目前，陈某某的所有社交媒体账号已被封禁，其创办的MCN机构也已暂停运营。51黑料吃瓜网将继续关注案件的司法进展，为大家带来最新报道。',
      },
    ],
  },
  {
    id: 5,
    slug: 'actress-divorce-scandal',
    title: '女星刘某某豪门婚变内幕：分居半年，财产分割或超十亿',
    subtitle: '知情人士披露更多离婚细节，涉及多处豪宅及公司股权分配',
    category: '娱乐圈八卦',
    date: '2026-07-02',
    author: '51爆料编辑部',
    heat: '198.2万',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20luxurious%20mansion%20at%20twilight%20with%20dramatic%20lighting%2C%20moody%20atmosphere%2C%20film%20grain%20texture%2C%20editorial%20photography%20style%2C%20warm%20golden%20windows%20glowing%20against%20dark%20sky%2C%20melancholic%20vibe&width=1600&height=700&seq=article-hero-05&orientation=landscape',
    contentSections: [
      {
        type: 'paragraph',
        text: '51黑料吃瓜网独家获悉，知名女星刘某某与富商丈夫的婚姻已走到尽头。据多位知情人士透露，两人已分居超过半年，目前正在进行财产分割谈判，涉及金额可能超过十亿元人民币。',
      },
      {
        type: 'heading',
        text: '豪门婚姻的裂痕',
      },
      {
        type: 'paragraph',
        text: '刘某某于2018年与某地产集团董事长之子结婚，婚礼耗资千万，一度被誉为"世纪婚礼"。婚后刘某某逐渐淡出演艺圈，专注于家庭生活。然而，据知情人士透露，两人的婚姻早在两年前就出现了裂痕。',
      },
      {
        type: 'paragraph',
        text: '"刘某某其实一直想复出拍戏，但男方家庭比较传统，不太支持她继续演艺事业。加上男方近年来事业遇到瓶颈，脾气变得越来越暴躁，两人经常因为各种琐事吵架。"一位接近刘某某的人士这样告诉51爆料网。',
      },
      {
        type: 'heading',
        text: '复杂的财产分割',
      },
      {
        type: 'paragraph',
        text: '据了解，两人名下共有豪宅5处（分别位于北京、上海、香港及海外），以及多家公司的股权。其中最引人注目的是男方家族企业的股份，刘某某通过婚后财产协议持有一定比例的权益。',
      },
      {
        type: 'paragraph',
        text: '目前双方的律师团队正在进行多轮谈判，但由于涉及资产规模庞大且结构复杂，预计短期内难以达成一致。51黑料吃瓜网将继续关注此事发展，为吃瓜群众带来后续报道。',
      },
    ],
  },
  {
    id: 6,
    slug: 'talent-show-fake-degree',
    title: '选秀冠军王某某学历造假？校方回应：正在核查中',
    subtitle: '网友晒出学信网查询截图，其声称的硕士学历无法查到对应记录',
    category: '明星黑料',
    date: '2026-07-01',
    author: '51爆料编辑部',
    heat: '89.7万',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20university%20campus%20at%20dusk%20with%20dramatic%20lighting%2C%20moody%20atmosphere%2C%20film%20grain%20texture%2C%20editorial%20photography%20style%2C%20warm%20golden%20light%20through%20buildings%2C%20contemplative%20vibe&width=1600&height=700&seq=article-hero-06&orientation=landscape',
    contentSections: [
      {
        type: 'paragraph',
        text: '近日，有网友在社交平台发帖质疑选秀冠军王某某的学历真实性。该网友表示，在学信网上未能查询到王某某所声称的"某985高校硕士"学历记录，引发广泛讨论。',
      },
      {
        type: 'heading',
        text: '网友发现疑点',
      },
      {
        type: 'paragraph',
        text: '据悉，王某某在参加选秀节目时，个人资料中标注为"硕士研究生学历，毕业于某知名985高校"。然而，有细心的网友在学信网（教育部指定的学历查询平台）上输入王某某的实名信息后，并未查到对应的硕士学历记录。',
      },
      {
        type: 'paragraph',
        text: '该网友晒出的截图显示，学信网仅能查到其本科学历信息，硕士学历一栏为空白。这一发现迅速在各大社交平台传播，"王某某学历造假"话题一度登上热搜。',
      },
      {
        type: 'heading',
        text: '校方回应：正在核查',
      },
      {
        type: 'paragraph',
        text: '51黑料吃瓜网记者就此事件联系了王某某所声称毕业的985高校。该校教务处工作人员表示："我们已经注意到网络上的相关讨论，目前正在对相关学籍信息进行核查，有结果后会第一时间公布。"',
      },
      {
        type: 'paragraph',
        text: '王某某方面目前仍未对此事做出公开回应。各位吃瓜群众，你们觉得这是系统延迟还是确有其事？欢迎在评论区留言讨论！',
      },
    ],
  },
];

export function getArticleBySlug(slug: string) {
  return articleData.find((a) => a.slug === slug) || null;
}